// extracted by mini-css-extract-plugin
export default {"imageWrapper":"fO-z","twoColumnImage":"gO-z"};